// extracted by mini-css-extract-plugin
module.exports = {"authBox":"authForm_authBox__1-1NS","loadingIcon":"authForm_loadingIcon__3XRU0","authForm":"authForm_authForm__2trIg","button":"authForm_button__1CypS"};